<div class="surface-card border-round-lg h-full">
  <div class="flex align-items-center justify-content-between pb-2 p-4">
    <div class="font-medium text-xl text-900">Versicherte Risiken</div>
    <div>

    </div>
  </div>
  <div class="max-h-28rem overflow-y-auto custom-scrollbar h-full p-4">
    @if (initialized && insurableObjects) {
      <ul class="list-none p-0 m-0">
        @for (insurableObject of insurableObjects; track $index) {

          <li
            class="cursor-pointer py-3 border-bottom-1 surface-border flex md:align-items-start md:justify-content-between flex-column md:flex-row"
            (click)="showContractsForObject(insurableObject)">
            <div class="flex align-items-start mr-0 lg:mr-5">
              <div class="image-wrapper mr-3 w-3rem h-3rem" (click)="openEditDialog(insurableObject, $event)">
                <img
                  insurableObjectImage
                  [insurableObject]="insurableObject"
                  class="w-full h-full border-circle object-cover"
                  loading="lazy" />

                <div class="edit-overlay">
                  <i class="pi pi-pencil"></i>
                </div>
              </div>

              <div>
                <span class="text-900 font-medium block mb-2">{{ insurableObject.typeName }}</span>
                <div class="text-700 mb-2">{{ insurableObject.name }}</div>
              </div>
            </div>
            <span class="block text-500 font-medium ml-7 md:ml-5 mt-2 md:mt-0" *ngIf="showContractCount">
              @if (insurableObject.numberOfContracts > 0) {
                <span>In {{ insurableObject.numberOfContracts }}
                  @if (insurableObject.numberOfContracts > 1) {
                    Verträgen
                  } @else {
                    Vertrag
                  }
                </span>
              }
            </span>
          </li>

        }
      </ul>

      <p-dialog [(visible)]="showEditDialog" header="Versichertes Risiko bearbeiten" [style]="{width: '40vw', height: '40vh'}">
        @if (selectedObject && showEditDialog) {
          <app-insurable-object-update [insurableObject]="selectedObject"></app-insurable-object-update>
        }
      </p-dialog>


    } @else {
      <div class="flex flex-column gap-2 align-items-center my-5">
        <i class="pi pi-search text-8xl text-200"></i>
        <h4 class="text-center">Hier werden deine versicherten Risiken angezeigt.</h4>
        <span class="text-color-secondary text-center">
            Aktuell sind hier keine versicherten Risiken aufgelistet. Das könnte daran liegen, dass du keinen aktiven Versicherungsvertrag hast oder deine Liste noch nicht aktualisiert wurde.
          </span>
      </div>
    }
  </div>
</div>


